// store/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const BASE_URL = process.env.REACT_APP_PP_URL;
// Async thunk to call API
export const fetchMyData = createAsyncThunk("api/fetchHomeData", async () => {
    const response = await fetch(`${BASE_URL}/guest-customer/v1/homePage/homepage-data`);
    const data = await response.json();
    return data; // return API response
});

export const BannerData = createAsyncThunk("api/fetchBanner", async () => {
    const res = await fetch(`${BASE_URL}/guest-customer/v1/homePage/banner-data`);
    const data = await res.json();
    return data;
});

export const fetchSocialMedia = createAsyncThunk("api/fetchSocialMedia", async () => {
    const res = await fetch(`${BASE_URL}/guest-customer/v1/homePage/contact-and-social`)
    const getRes = await res.json();
    return getRes;
})

const apiSlice = createSlice({
    name: "api",
    initialState: {
        homeData: [],
        banners: [],
        socialMedia: [],
        status: "idle", // idle | loading | succeeded | failed
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMyData.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchMyData.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.homeData = action.payload;
            })
            .addCase(fetchMyData.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(BannerData.pending, (state) => {
                state.status = "loading";
            })
            .addCase(BannerData.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.banners = action.payload;
            })
            .addCase(BannerData.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(fetchSocialMedia.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchSocialMedia.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.socialMedia = action.payload;
            })
            .addCase(fetchSocialMedia.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export default apiSlice.reducer;
